import { CenteredLayout, CenteredLayoutVariant } from "@/components/layouts/centered-layout";
import { Skeleton } from "@/components/ui/skeleton";

export function CustomerDetailSkeleton() {
  return (
    <CenteredLayout variant={CenteredLayoutVariant.Default}>
      <div className="flex flex-col gap-6">
        <Skeleton className="h-8 w-64" />
        <Skeleton className="h-56 w-full rounded-lg" />
        <Skeleton className="h-40 w-full rounded-lg" />
        <Skeleton className="h-40 w-full rounded-lg" />
      </div>
    </CenteredLayout>
  );
}
